/* Raninos Balloons — interacciones del tema */
(function(){
  var money = function(cents){ return (cents/100); };

  /* ---------- Cart drawer ---------- */
  function drawer(){ return document.getElementById('ra-drawer'); }
  function overlay(){ return document.getElementById('ra-overlay'); }
  function openCart(){ if(drawer()){ drawer().classList.add('is-open'); overlay().classList.add('is-open'); } }
  function closeCart(){ if(drawer()){ drawer().classList.remove('is-open'); overlay().classList.remove('is-open'); } }
  window.raOpenCart = openCart; window.raCloseCart = closeCart;

  function toast(msg){
    var t = document.getElementById('ra-toast');
    if(!t) return;
    t.innerHTML = '<i>&#10003;</i>' + (msg || (window.raninosStrings && window.raninosStrings.added) || 'Agregado');
    t.classList.add('is-show');
    clearTimeout(window._raToast);
    window._raToast = setTimeout(function(){ t.classList.remove('is-show'); }, 2400);
  }

  function fetchCart(){
    return fetch(window.routes.cart_url + '.js', {headers:{'Accept':'application/json'}}).then(function(r){return r.json();});
  }

  function renderCart(cart){
    // count badges
    document.querySelectorAll('[data-cart-count]').forEach(function(el){
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? '' : 'none';
    });
    var body = document.getElementById('ra-drawer-items');
    var foot = document.getElementById('ra-drawer-foot');
    if(!body) return;
    if(cart.item_count === 0){
      body.innerHTML = document.getElementById('ra-empty-tpl').innerHTML;
      if(foot) foot.style.display = 'none';
      return;
    }
    var html = '';
    cart.items.forEach(function(it){
      html += '<div class="ra-citem" data-key="'+it.key+'">'+
        '<div class="ra-citem__img"><img src="'+(it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/,'_150x$1$2') : '')+'" alt=""></div>'+
        '<div style="flex:1;min-width:0">'+
          '<div class="ra-citem__name">'+it.product_title+'</div>'+
          (it.variant_title && it.variant_title !== 'Default Title' ? '<div style="font-weight:600;color:#6A6474;font-size:13px">'+it.variant_title+'</div>' : '')+
          '<div class="ra-citem__price">'+formatMoney(it.final_line_price)+'</div>'+
          '<div class="ra-citem__qty">'+
            '<button data-change="'+it.key+'" data-to="'+(it.quantity-1)+'">&minus;</button>'+
            '<span>'+it.quantity+'</span>'+
            '<button data-change="'+it.key+'" data-to="'+(it.quantity+1)+'">+</button>'+
            '<button class="ra-citem__rm" data-change="'+it.key+'" data-to="0">Quitar</button>'+
          '</div>'+
        '</div>'+
      '</div>';
    });
    body.innerHTML = html;
    if(foot){
      foot.style.display = '';
      var sub = document.getElementById('ra-drawer-subtotal');
      if(sub) sub.textContent = formatMoney(cart.total_price);
    }
  }

  function formatMoney(cents){
    var fmt = window.raMoneyFormat || '${{amount}}';
    if(typeof cents === 'string'){ cents = cents.replace('.',''); }
    function defaultTo(v,d){ return (v===undefined||v===null) ? d : v; }
    function fmtNum(num, precision, thousands, decimal){
      precision = defaultTo(precision,2); thousands = defaultTo(thousands,','); decimal = defaultTo(decimal,'.');
      if(isNaN(num)||num===null) return 0;
      num = (num/100).toFixed(precision);
      var parts = num.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1'+thousands),
          cents2 = parts[1] ? (decimal + parts[1]) : '';
      return dollars + cents2;
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function(match, name){
      switch(name){
        case 'amount': return fmtNum(cents,2);
        case 'amount_no_decimals': return fmtNum(cents,0);
        case 'amount_with_comma_separator': return fmtNum(cents,2,'.',',');
        case 'amount_no_decimals_with_comma_separator': return fmtNum(cents,0,'.',',');
        case 'amount_with_space_separator': return fmtNum(cents,2,' ','.');
        case 'amount_no_decimals_with_space_separator': return fmtNum(cents,0,' ','.');
        default: return fmtNum(cents,2);
      }
    });
  }

  function change(key, qty){
    return fetch(window.routes.cart_change_url + '.js', {
      method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ id:key, quantity:qty })
    }).then(function(r){return r.json();}).then(renderCart);
  }

  function addFromForm(form){
    var btn = form.querySelector('[type="submit"]');
    var data = new FormData(form);
    if(btn){ btn.setAttribute('disabled','disabled'); }
    fetch(window.routes.cart_add_url + '.js', {
      method:'POST', headers:{'Accept':'application/json'}, body:data
    }).then(function(r){return r.json();}).then(function(){
      return fetchCart();
    }).then(function(cart){
      renderCart(cart); toast(); openCart();
    }).catch(function(){}).finally(function(){ if(btn){ btn.removeAttribute('disabled'); } });
  }

  document.addEventListener('click', function(e){
    var open = e.target.closest('[data-cart-open]');
    if(open){ e.preventDefault(); openCart(); }
    var close = e.target.closest('[data-cart-close]');
    if(close){ e.preventDefault(); closeCart(); }
    var ch = e.target.closest('[data-change]');
    if(ch){ e.preventDefault(); change(ch.getAttribute('data-change'), parseInt(ch.getAttribute('data-to'),10)); }
    var nav = e.target.closest('[data-nav-toggle]');
    if(nav){
      var panel = document.getElementById('ra-mobile-nav');
      if(panel){ var open = panel.classList.toggle('is-open'); nav.setAttribute('aria-expanded', open ? 'true' : 'false'); }
    }
  });

  document.addEventListener('submit', function(e){
    var form = e.target.closest('form[data-ra-add]');
    if(form){ e.preventDefault(); addFromForm(form); }
  });

  /* ---------- PDP gallery ---------- */
  document.addEventListener('click', function(e){
    var thumb = e.target.closest('.ra-thumb');
    if(thumb){
      var main = document.querySelector('.ra-gallery__main img');
      var src = thumb.getAttribute('data-full');
      if(main && src){ main.src = src; }
      document.querySelectorAll('.ra-thumb').forEach(function(t){t.classList.remove('is-active');});
      thumb.classList.add('is-active');
    }
  });

  /* ---------- PDP quantity ---------- */
  document.addEventListener('click', function(e){
    var q = e.target.closest('[data-qty]');
    if(!q) return;
    var input = document.getElementById('ra-qty-input');
    if(!input) return;
    var v = parseInt(input.value,10) || 1;
    v += (q.getAttribute('data-qty') === 'up' ? 1 : -1);
    input.value = Math.max(1, v);
  });

  /* ---------- PDP variant selection updates price + form id ---------- */
  window.raSelectVariant = function(btn, groupName){
    var group = btn.closest('[data-variant-group]');
    group.querySelectorAll('.ra-swatch').forEach(function(s){s.classList.remove('is-active');});
    btn.classList.add('is-active');
    var form = document.querySelector('form[data-ra-add]');
    if(!form) return;
    var selected = {};
    document.querySelectorAll('[data-variant-group] .ra-swatch.is-active').forEach(function(s){
      selected[s.getAttribute('data-option')] = s.getAttribute('data-value');
    });
    var variants = window.raVariants || [];
    var match = variants.find(function(v){
      return v.options.every(function(opt,i){ return selected['option'+(i+1)] === undefined || selected['option'+(i+1)] === opt; });
    });
    if(match){
      var idInput = form.querySelector('input[name="id"]');
      if(idInput) idInput.value = match.id;
      var priceEl = document.getElementById('ra-pdp-price');
      if(priceEl) priceEl.textContent = formatMoney(match.price);
      var btnPrice = document.getElementById('ra-add-price');
      if(btnPrice) btnPrice.textContent = formatMoney(match.price);
    }
  };

  /* ---------- Collection sort auto-submit ---------- */
  document.addEventListener('change', function(e){
    if(e.target.matches('#ra-sort')){ e.target.form.submit(); }
    if(e.target.matches('.ra-facets input')){ e.target.form.submit(); }
  });

  /* init count on load */
  document.addEventListener('DOMContentLoaded', function(){ fetchCart().then(renderCart); });
})();
